<template lang="pug">
  Icon.icon(name="notification-play" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Вам назначена роль {{ item.info.roleName }} в отделе {{ item.info.departmentName }} компании
    a(:href="$router.resolve({ name: 'company-detail', params: { companyId: item.info.companyId } }).href")  {{ item.info.companyName }}
</template>

<script>
export default {
  name: 'NotificationCompanyDepartmentMemberRoleUpdated',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
